import { render } from "./VerticalProductsScrollMenu.vue?vue&type=template&id=9469be3e"
import script from "./VerticalProductsScrollMenu.vue?vue&type=script&lang=js"
export * from "./VerticalProductsScrollMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__